/* jQuery, Bloodhound */

'use strict';

import '../../../js/vendor/typeaheadjs/dist/typeahead.jquery.js';
import Bloodhound from '../../../js/vendor/typeaheadjs/dist/bloodhound.min.js';

class Typeahead {
    wrap;
    bloodhoundArr;
    ui;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                typeaheadInputs: $('.js-typeahead-input'),
                searchType: $('.js-typeahead-input-search-type')
            };

            this.bloodhoundArr = [];

            window.addEventListener('load', () => this.implementTypeahead());

            if (this.ui.searchType.length) {
                $(this.wrap).bind('typeahead:select', (ev, suggestion) => {
                    suggestion.type ?
                        $(this.ui.searchType).val(suggestion.type) :
                        $(this.ui.searchType).val('');
                    this.wrap.submit();
                });
            }
        }
    }

    implementTypeahead() {
        this.ui.typeaheadInputs.each((index, input) => {
            var thisInput = $(input),
                jsonInDom = $('.' + thisInput.data('json-identifier')),
                jsonArr = [];

            if (jsonInDom.length) {
                jsonInDom.each((i, el) => {
                    jsonArr.push(JSON.parse($(el).html()));
                });
            }

            // Implement Bloodhound
            // Pushes each dataset into an array as a bloodhound object of suggestions
            $(jsonArr).each((i, json) => {
                this.bloodhoundArr.push(new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    local: json.results.map(result => ({
                        name: result.name + ' ' + result.helper,
                        value: result.name,
                        helper: result.helper,
                        type: result.type,
                        header: json.title,
                    })),
                }));
            });

            // Implement Typeahead
            // "apply" is used because typeahead takes an argument list for its data sources (not an array)
            // We don't know how many data sources there are, so "apply" converts
            // the array of data sources into an argument list
            thisInput.typeahead.apply(thisInput, [{
                hint: true,
                highlight: true,
                minLength: 2,
            }].concat(
                this.bloodhoundArr.map((source, index) => {
                    return {
                        name: source.length ? source[0].header : `data_${index}`,
                        source: source,
                        display: 'value',
                        displayKey: 'value',
                        limit: 8,
                        templates: {
                            header: (query) => query.suggestions[0].header ? `
                                <h3 class="twitter-typeahead__header">${query.suggestions[0].header}</h3>
                            ` : undefined,
                            suggestion: (data) => `
                                <div class="twitter-typeahead__suggestion">
                                    <span class="twitter-typeahead__suggestion-name">${data.value}</span>
                                    ${data.helper ? ` - ${data.helper}` : ''}
                                </div>
                            `
                        }
                    };
                }
            )));

        });
    }
}

export default Typeahead;
